<template>
  <div id="start-animation" class="bg-light">
    <div id="container" ref="container">
      <img id="logo" src="../../assets/images/logo.png" ref="logo" />
      <div class="typewriter">
        <h1 ref="name">eisson</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'startAnimation',
  mounted () {
    this.$refs.logo.addEventListener('animationend', (event) => {
      if (event.animationName === 'spin') {
        this.$refs.name.classList.add('animate')
      }
    })

    this.$refs.name.addEventListener('animationend', (event) => {
      if (event.animationName === 'typing') {
        this.$refs.container.style.animationName = 'locate'
        this.$refs.logo.style.animationName = 'resize-logo'
        this.$refs.name.style.animationName = 'resize-name'
      } else if (event.animationName === 'resize-name') {
        this.$emit('loaded')
      }
    })
  }
}
</script>

<style lang="scss">
#start-animation {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

#container {
  position: fixed;
  top: calc(50% - 56px);
  left: calc(50% - 142px);
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  animation-duration: 0.8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

/* DEMO-SPECIFIC STYLES */
.typewriter h1 {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: .15em; /* Adjust as needed */
  width: 0;
}

h1.animate {
  border-right: .15em solid orange; /* The typwriter cursor */
  animation:
    typing 1s steps(30, end) forwards,
    blink-caret .5s step-end infinite;
}

#logo {
  animation-name: spin, fade;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fade {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg) scale(0);
  }

  70% {
    transform: rotate(1080deg) scale(1.2);
  }

  100% {
    transform: rotate(1080deg) scale(1);
  }
}

@keyframes locate {
  0% {
    top: calc(50% - 56px);
    left: calc(50% - 142px);
  }

  100% {
    top: 16px;
    left: 15px;
  }
}

@keyframes resize-logo {
  0% {
    height: 112px;
    width: 90px;
  }

  100% {
    height: 30px;
    width: 25px;
    position: relative;
    top: -3px;
  }
}

@keyframes resize-name {
  0% {
    font-size: 2.5rem;
    width: 100%;
    border-right: none;
  }

  100% {
    font-size: 20px;
    width: 100%;
    border-right: none;
    letter-spacing: initial;
  }
}

/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange }
}
</style>
